"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".checkbox-group .checkbox {\n  margin-bottom: 8px; }\n";
  const fileName = "CheckboxGroup_CheckboxGroup";
  const element = document.querySelector("style[data-sass-component='CheckboxGroup_CheckboxGroup']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const CheckboxGroup = _ref => {
  let {
    title,
    items,
    formValues,
    handleCheckboxChange,
    error
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'checkbox-group'
  }, title && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-05 sia-padding-01-bottom"
  }, title), items.map(item => /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    key: item.value,
    id: item.value,
    label: item.label,
    value: formValues ? formValues.includes(item.value) || false : false,
    onChange: (event, value) => handleCheckboxChange(item.value, value)
  })), error && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-07 sia-margin-01-top"
  }, error));
};
CheckboxGroup.propTypes = {
  title: _propTypes.default.string,
  items: _propTypes.default.array.isRequired,
  formValues: _propTypes.default.array.isRequired,
  handleCheckboxChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.string
};
var _default = exports.default = CheckboxGroup;